import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import DomainDescription from './DomainDescription';
import DomainSelect from './DomainSelect';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  }
});

const Main = ({ classes, showValidation, onDataChange }) => {
  return (
    <div className={classes.root}>
      <DomainDescription />
      <DomainSelect showValidation={showValidation} onDataChange={onDataChange} />
    </div>
  )
}

export default withStyles(styles)(Main);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Domain/Main.jsx